// extracted by mini-css-extract-plugin
export var infoRow = "_r4-2";
export var labelContainer = "_r4-0";
export var rightInfo = "_r4-1";